import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Bezorging',
  [ORDER_METHODS.pickup]: 'Afhalen',
  [ORDER_METHODS.on_site]: 'Tafelbestellen',
};
